module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container mb-4 p-sm-3 col-md-8"
  }, [_c('h1', [_vm._v("\n    撮影会／イベント／教室 開催後報告\n  ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('form', {
    staticClass: "mb-5",
    attrs: {
      "action": "index.html",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group p-3"
  }, [_c('label', {
    attrs: {
      "for": "lecturer-number"
    }
  }, [_vm._v("イベントタイトル")]), _vm._v(" "), _c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.item.event_name))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group p-3"
  }, [_c('label', {
    attrs: {
      "for": "lecturer-number"
    }
  }, [_vm._v("掲載終了日")]), _vm._v(" "), _c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.item.end_date))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group p-3"
  }, [_c('label', {
    attrs: {
      "for": "EventReport"
    }
  }, [_vm._v("参加人数（組数）")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.eventReport.event_report))])]), _vm._v(" "), _c('p', [_vm._v(" 内容を確認の上、よろしければ事務局宛にメールを送信します。")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "group"
    }
  }, [_c('router-link', {
    staticClass: "btn btn-outline-info btn-lg",
    attrs: {
      "to": _vm.inputPath
    }
  }, [_vm._v("修正する")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-lg text-white",
    class: _vm.submitStyle,
    attrs: {
      "href": "/lecturer/list"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.submit()
      }
    }
  }, [_vm._v("事務局へ報告")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "text-right mt-5"
  }, [_c('router-link', {
    attrs: {
      "to": "/mypage"
    }
  }, [_vm._v("マイページへのリンク")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "attention"
  }, [_vm._v("※")]), _vm._v("必須\n  ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-569dd1e1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lecturer/event/ReportConfirm.vue
// module id = 337
// module chunks = 1